import { generatePath } from "react-router";
import { CHECKOUT_PATH, checkoutParamNames } from "./consts.js";
import { toUrlParams } from "@holisto-web/shared/url-params";

interface CheckoutPath {
  checkoutId: string;
  hotelId: number;
  dealKey?: string;
  trvContext?: string;
  sig?: string;
  trvGroup?: string;
  tripKey?: string;
}

export const getCheckoutPath = ({
  checkoutId,
  hotelId,
  dealKey,
  trvContext,
  sig,
  trvGroup,
  tripKey,
}: CheckoutPath): string => {
  const checkoutPath = generatePath(CHECKOUT_PATH, {
    [checkoutParamNames.checkoutId]: checkoutId,
    [checkoutParamNames.hotelId]: String(hotelId),
  });

  const params = toUrlParams({
    [checkoutParamNames.dealKey]: dealKey,
    [checkoutParamNames.trvContext]: trvContext,
    [checkoutParamNames.sig]: sig,
    [checkoutParamNames.trvGroup]: trvGroup,
    [checkoutParamNames.tripKey]: tripKey,
  });

  return `${checkoutPath}${params ? `?${params}` : ""}`;
};
